import { Link } from "react-router-dom";
import { allCategories, allSoftware, formatDownloads, sortSoftware } from "@/utils/software";

const hotSoftware = sortSoftware(allSoftware, "downloads").slice(0, 5);

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-950 text-background-200">
      <div className="container-page grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-foreground-950">
              <i className="ri-hand-coin-line" />
            </span>
            <span className="font-heading text-base font-bold text-background-50">
              黄金网站软件app免费
            </span>
          </div>
          <p className="text-sm leading-relaxed text-background-300">
            专注黄金投资软件与应用的推荐与免费下载，聚合趋势分析、价格监控、理财工具与行情资讯，帮助投资者更高效地掌握黄金市场。
          </p>
          <div className="flex flex-wrap gap-2">
            {["免费下载", "安全无毒", "持续更新"].map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-secondary-700 px-3 py-1 text-xs text-primary-200"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading text-sm font-bold text-background-50">软件分类</h4>
          <ul className="flex flex-col gap-2 text-sm">
            {allCategories.map((cat) => (
              <li key={cat.id}>
                <Link
                  to={`/category/${cat.id}`}
                  className="flex items-center gap-2 text-background-300 transition-colors hover:text-primary-300"
                >
                  <i className={cat.icon} />
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading text-sm font-bold text-background-50">热门下载</h4>
          <ul className="flex flex-col gap-2 text-sm">
            {hotSoftware.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/detail/${item.id}`}
                  className="flex items-center justify-between gap-3 text-background-300 transition-colors hover:text-primary-300"
                >
                  <span className="truncate">{item.name}</span>
                  <span className="shrink-0 text-xs text-background-400">
                    {formatDownloads(item.downloads)}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="font-heading text-sm font-bold text-background-50">联系我们</h4>
          <ul className="flex flex-col gap-2 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-300" />
              service@huangjinruanjianapp.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-wechat-line text-primary-300" />
              微信公众号：黄金软件导航
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-300" />
              服务时间：周一至周五 9:00-18:00
            </li>
          </ul>
          <Link to="/about" className="btn-primary mt-1 w-fit text-sm">
            了解我们 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="container-page flex flex-col gap-3 py-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黄金网站软件app免费 · 本站软件均为演示资源，下载链接为示范地址</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="text-background-400">友情链接：</span>
            <a
              href="https://example.com"
              rel="nofollow"
              className="transition-colors hover:text-primary-300"
            >
              黄金行情资讯
            </a>
            <a
              href="https://example.com"
              rel="nofollow"
              className="transition-colors hover:text-primary-300"
            >
              财经数据平台
            </a>
            <a
              href="https://example.com"
              rel="nofollow"
              className="transition-colors hover:text-primary-300"
            >
              理财工具导航
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}